import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';
import { XLarge } from '@outdoor-voices/ui';
import BraSizeIcon from './icons/BraSize';
import css from './SizeGuide.module.scss';
import SizeGuideIcon from './icons/SizeGuide';
import SizingGeneral from './SizingGeneral';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var SizeGuide = function SizeGuide() {
  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      guide = _useState2[0],
      setGuide = _useState2[1];

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!guide && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        className: css.title,
        children: "Find Your Size"
      }), /*#__PURE__*/_jsxs("ul", {
        className: css.list,
        children: [/*#__PURE__*/_jsx("li", {
          className: css.item,
          children: /*#__PURE__*/_jsxs("button", {
            "aria-label": "View the apparel size guide",
            className: css.button,
            onClick: function onClick() {
              return setGuide('Apparel');
            },
            type: "button",
            children: [/*#__PURE__*/_jsx("span", {
              className: css.icon,
              children: /*#__PURE__*/_jsx(SizeGuideIcon, {})
            }), /*#__PURE__*/_jsx("span", {
              className: css.subtitle,
              children: "Apparel"
            })]
          })
        }), /*#__PURE__*/_jsx("li", {
          className: css.item,
          children: /*#__PURE__*/_jsxs("button", {
            "aria-label": "View the bra size guide",
            className: css.button,
            onClick: function onClick() {
              return setGuide('Bra Size');
            },
            type: "button",
            children: [/*#__PURE__*/_jsx("span", {
              className: css.icon,
              children: /*#__PURE__*/_jsx(BraSizeIcon, {})
            }), /*#__PURE__*/_jsx("span", {
              className: css.subtitle,
              children: "Bra Size"
            })]
          })
        })]
      })]
    }), guide && /*#__PURE__*/_jsxs("div", {
      className: css.guide,
      children: [/*#__PURE__*/_jsx("button", {
        "aria-label": "Close the ".concat(guide, " guide"),
        className: css.close,
        onClick: function onClick() {
          return setGuide(null);
        },
        type: "button",
        children: /*#__PURE__*/_jsx(XLarge, {})
      }), /*#__PURE__*/_jsxs("div", {
        className: css.guideHeader,
        children: [/*#__PURE__*/_jsx("span", {
          className: css.icon,
          children: guide === 'Apparel' ? /*#__PURE__*/_jsx(SizeGuideIcon, {}) : /*#__PURE__*/_jsx(BraSizeIcon, {})
        }), /*#__PURE__*/_jsx("span", {
          className: css.subtitle,
          children: guide
        })]
      }), /*#__PURE__*/_jsx(SizingGeneral, {
        type: guide
      })]
    })]
  });
};

export default SizeGuide;